type CriteriaIndicatorIconProps = {
  met: boolean;
  size?: number;
};

const UNMET_COLOR = '#ceced2';
const MET_COLOR = '#018964';

const CriteriaIndicatorIcon = ({
  met,
  size = 12,
}: CriteriaIndicatorIconProps) => {
  const color = met ? MET_COLOR : UNMET_COLOR;

  if (met) {
    return (
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden={true}
      >
        <path
          d="M18.0003 0.857056H6.00028C3.15996 0.857056 0.857422 3.1596 0.857422 5.99991V17.9999C0.857422 20.8403 3.15996 23.1428 6.00028 23.1428H18.0003C20.8407 23.1428 23.1431 20.8403 23.1431 17.9999V5.99991C23.1431 3.1596 20.8407 0.857056 18.0003 0.857056Z"
          stroke={color}
          strokeWidth="1.71429"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.0008 8.14276L10.1437 16.7142L6.71509 14.1428"
          stroke={color}
          strokeWidth="1.71429"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden={true}
    >
      <path
        d="M18.0003 0.857056H6.00028C3.15996 0.857056 0.857422 3.1596 0.857422 5.99991V17.9999C0.857422 20.8403 3.15996 23.1428 6.00028 23.1428H18.0003C20.8407 23.1428 23.1431 20.8403 23.1431 17.9999V5.99991C23.1431 3.1596 20.8407 0.857056 18.0003 0.857056Z"
        stroke={color}
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 12H16"
        stroke={color}
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CriteriaIndicatorIcon;
